<template>
  <div class="d-flex justify-center align-center" fill-height style="background-color:#EFEFEF; height: 100vh; margin:0px;">

          <div class="d-flex justify-center align-center elevation-20 rounded-xl" style="overflow:hidden; height:600px;background-color:white;">
      
      <div class="pa-6 d-flex justify-center align-stretch" style="width:520px; background-color:white; height:100%;">
<div style="width:100%;" class="d-flex; justify-center;">
         
<div class="d-flex flex-grow-1  flex-column justify-center" style="margin:auto;height:100%; width:70%;">
  <div>
        <h1>Setup Account</h1>
        <div class="mb-5">Just a bit more info to get us started</div>

        <v-text-field v-model="form.businessName" outlined label="Business Name">Business Name</v-text-field>
        <v-text-field v-model="form.businessPostcode" outlined label="Business Postcode">PostCode</v-text-field>
  
     

        <v-text-field v-model="form.yourName" outlined label="Your Name">Name</v-text-field>
        <v-text-field v-model="form.yourMobile" outlined label="Mobile">Mobile</v-text-field>
        <div style="text-align:right;">
        <v-btn @click="register" rounded style="color:#FFF; background: linear-gradient(317deg, rgba(34,193,195,0.4) 0%, rgba(253,187,45,0.4) 100%);" elevation="3">Continue</v-btn>
</div>
</div>
</div></div>
      </div>
      <div class="d-flex justify-end align-end flex-column" style="width:620px;background: linear-gradient(317deg, rgba(34,150,150,0.4) 0%, rgba(253,187,45,0.4) 100%);height:100%;">
               <div style="width:100%;text-align:center;">
                 <h1 style="width:100%; color:#FFF; text-shadow:0px 0px 15px rgba(0,0,0,0.35); text-align:center;" class="pa-10">easysign.in</h1>
             </div>
<img width="70%" height="70%" src="/loginImage.png" />



      </div>
     </div> 

  </div>
</template>

<script>


import axios from 'axios';
import * as firebase from 'firebase/app';

// eslint-disable-next-line
import * as firebaseAuth from 'firebase/auth';


import { mapMutations } from 'vuex';
import {mapGetters} from 'vuex';

export default {
 data () {
      return {
        form:{
          yourEmail:"",
          password:"",
          yourName: "",
          yourMobile: "",
          businessName:"",
          businessPostcode:"",
        },
           rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => (`The email and password you entered don't match`),
        },
      }
 },
 computed:{
      ...mapGetters(["getAxiosConfig"]),
    },
    methods:
    {
      ...mapMutations([
        "setIdToken"
      ]),
       register: function(){
              var t = this;
              firebase.auth().currentUser.getIdToken().then(function(idToken) {  
                  t.setIdToken(idToken);


           
                  axios.post(
                  t.GLOBAL_CONFIG.apiURL + "Account",
                  {
                    "businessName": t.form.businessName,
                    "businessPostcode": t.form.businessPostcode,
                    "yourName": t.form.yourName,
                    "yourMobile": t.form.yourMobile,
                    "yourEmail": t.form.yourEmail
                  },
                  t.getAxiosConfig
                  ).then(data=>{t.$router.push("/admin/splash")});


                });


       }
  }
 
}
</script>

<style lang="scss" scoped>

</style>